import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { emailStatuses } from 'types/models';
import { z } from 'zod';

export const adminUsersRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/users',
  validateSearch: z.object({
    page: zodPage,
    query: z.string().optional(),
    email_statuses: z.array(z.enum(emailStatuses)).optional(),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/admin/Users/AdminUsersPage/AdminUsersPage').then((d) => d.Route));
